import { render, staticRenderFns } from "./TourismProduct.vue?vue&type=template&id=471988c5&scoped=true&"
import script from "./TourismProduct.vue?vue&type=script&lang=js&"
export * from "./TourismProduct.vue?vue&type=script&lang=js&"
import style0 from "./TourismProduct.vue?vue&type=style&index=0&id=471988c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471988c5",
  null
  
)

export default component.exports